/**
 * Supported cross-chain networks, keyed by the chain id the backend projects on
 * cross-chain docs. EVM networks use their real chain id; non-EVM ones use the
 * id Relay assigns them (Solana is 792703809 and Tron is 728126428, neither an
 * EVM chain id). Keep this in sync with `RELAY_SUPPORTED_CHAINS` in the wallet
 * service's `causa.yaml` PLUS the receive-only origins in its
 * `providers/bridge/relay/receive-currency.ts` (Tron is receive-only: USDT
 * TRC-20 in, USDC out, and it never appears in the send destination list).
 *
 * Used to render chain columns/fields as human names instead of bare numbers.
 * Unknown ids fall back to `Chain {id}` so a new backend-supported chain never
 * renders blank.
 */
const CHAIN_NAMES: Record<number, string> = {
  1: "Ethereum",
  10: "Optimism",
  137: "Polygon",
  8453: "Base",
  42161: "Arbitrum",
  999: "HyperEVM",
  792703809: "Solana",
  728126428: "Tron",
};

export function chainName(id: number | null | undefined): string {
  if (id === null || id === undefined) return "—";
  return CHAIN_NAMES[id] ?? `Chain ${id}`;
}
